import { render, staticRenderFns } from "./EndViewCategory.vue?vue&type=template&id=612d17e3&scoped=true"
import script from "./EndViewCategory.vue?vue&type=script&lang=ts"
export * from "./EndViewCategory.vue?vue&type=script&lang=ts"
import style0 from "./EndViewCategory.vue?vue&type=style&index=0&id=612d17e3&prod&lang=scss&scoped=true"
import style1 from "./EndViewCategory.vue?vue&type=style&index=1&id=612d17e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d17e3",
  null
  
)

export default component.exports